'use client';

import dynamic from 'next/dynamic';
import { Brain } from 'lucide-react';

const IntentRadialChart = dynamic(() => import('./IntentRadialChart'), { ssr: false });

export default function IntentGraphWidget() {
  return (
    <div className="card-elevated p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-primary/15 flex items-center justify-center">
            <Brain size={14} className="text-accent" />
          </div>
          <span className="text-sm font-600 text-foreground">IntentGraph</span>
        </div>
        <button className="text-xs text-accent hover:underline">Edit</button>
      </div>

      <p className="text-xs text-muted-foreground mb-3">
        Your current interest distribution — updated as you engage.
      </p>

      <IntentRadialChart />

      <div className="mt-3 space-y-1.5">
        {[
          { topic: 'machine-learning', pct: 34, color: 'bg-violet-500' },
          { topic: 'distributed-systems', pct: 24, color: 'bg-cyan-500' },
          { topic: 'ux-design', pct: 18, color: 'bg-amber-500' },
          { topic: 'security', pct: 14, color: 'bg-emerald-500' },
          { topic: 'startups', pct: 10, color: 'bg-pink-500' },
        ]?.map((item) => (
          <div key={`intent-${item?.topic}`} className="flex items-center gap-2">
            <div className={`w-2 h-2 rounded-full ${item?.color} flex-shrink-0`} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-0.5">
                <span className="text-xs text-muted-foreground truncate">#{item?.topic}</span>
                <span className="text-xs font-600 text-foreground numeric-tabular ml-2">{item?.pct}%</span>
              </div>
              <div className="h-1 bg-muted rounded-full overflow-hidden">
                <div
                  className={`h-full ${item?.color} rounded-full`}
                  style={{ width: `${item?.pct}%` }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-3 pt-3 border-t border-border flex items-center gap-1.5">
        <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
        <span className="text-xs text-muted-foreground">Updated 4 minutes ago</span>
      </div>
    </div>
  );
}